import React from "react";
import { useRef, useState, useEffect } from "react";
import "./CloudmanageDiverse.css";
import process1 from "../../vision/visionassets/diverse1.png";
import process2 from "../../vision/visionassets/diverse2.png";
import process3 from "../../vision/visionassets/diverse3.png";
import process4 from "../../vision/visionassets/diverse4.png";
import process5 from "../../vision/visionassets/diverse5.png";
import process6 from "../../vision/visionassets/diverse6.png";

const processCards = [
  {
    id: 1,
    image: process1,
    title: "dApp Ideation",
    description:
      "Before starting the process, we collaborate to brainstorm ideas and understand your business needs. Our dApp experts define the technical components, on-chain and off-chain entities, and the complete development roadmap.",
  },
  {
    id: 2,
    image: process2,
    title: "Concept Framework",
    description:
      "Our dApp development team evaluates leading blockchain technologies—such as Ethereum, HashGraph, Hyperledger, and Lightning Network—selects the ideal use case for a POC, and then advances to full development.",
  },
  {
    id: 3,
    image: process3,
    title: "Technical Design",
    description:
      "To deliver a scalable dApp, our developers craft an intuitive user interface and robust technical architecture. We also ensure GDPR compliance throughout milestones and documentation.",
  },
  {
    id: 4,
    image: process4,
    title: "Development & API Integration Layer",
    description:
      "In this phase, we write the dApp’s code, develop smart contracts using languages like Solidity, Vyper, or Cairo, and integrate them with decentralized blockchain networks such as Ethereum.",
  },
  {
    id: 5,
    image: process5,
    title: "Technical Design",
    description:
      "Your PWA is tested across devices, browsers, and network speeds with Lighthouse audits, offline simulations, and performance checks for metrics like LCP, FCP, and TTI.",
  },
  {
    id: 6,
    image: process6,
    title: "Technical Design",
    description:
      "We deploy your PWA, configure analytics, monitor service worker updates, and fine-tune caching, asset delivery, and UI responsiveness based on real user performance data.",
  },
];

export default function CloudmanageDiverse() {
  const scrollContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } =
        scrollContainerRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  useEffect(() => {
    checkScroll();
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
      return () => {
        container.removeEventListener("scroll", checkScroll);
        window.removeEventListener("resize", checkScroll);
      };
    }
  }, []);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 450;
      const newScrollLeft =
        direction === "left"
          ? scrollContainerRef.current.scrollLeft - scrollAmount
          : scrollContainerRef.current.scrollLeft + scrollAmount;

      scrollContainerRef.current.scrollTo({
        left: newScrollLeft,
        behavior: "smooth",
      });
    }
  };

  const getCardScrollWidth = () => {
    if (!scrollContainerRef.current) return 0;
    const card = scrollContainerRef.current.querySelector(".card");
    if (!card) return 0;

    const gap = 24;
    return card.offsetWidth + gap;
  };

  return (
    <div id="manage-diverse">
      <div className="top">
        <h2 className="heading">dApp Development Process We Follow</h2>
        <p className="subheading">
          We build reliable, scalable decentralized exchange apps with agile
          methods and DevOps for fast, robust delivery.{" "}
        </p>
      </div>
      <div className="slider-wrapper">
        {canScrollLeft && (
          <button
            onClick={() => scroll("left")}
            className="scroll-button scroll-button-left"
          >
            ←
          </button>
        )}

        <div
          ref={scrollContainerRef}
          className={`cards-container ${!canScrollLeft ? "padding-left" : ""} ${
            !canScrollRight ? "padding-right" : ""
          }`}
        >
          {processCards.map((card) => (
            <div key={card.id} className="card" style={{ background: card.bg }}>
              <div className="card-container-main">
                <img src={card.image} alt={card.title} className="card-image" />
                <h2 className="card-title">{card.title}</h2>
                <p className="card-description">{card.description}</p>
              </div>
            </div>
          ))}
        </div>

        {canScrollRight && (
          <button
            onClick={() => scroll("right")}
            className="scroll-button scroll-button-right"
          >
            →
          </button>
        )}
      </div>
      <div className="custom-dots">
        {processCards.map((_, index) => (
          <button
            key={index}
            className={`dot ${
              index ===
              Math.round(
                (scrollContainerRef.current?.scrollLeft || 0) /
                  getCardScrollWidth(),
              )
                ? "active"
                : ""
            }`}
            onClick={() => {
              scrollContainerRef.current?.scrollTo({
                left: index * getCardScrollWidth(),
                behavior: "smooth",
              });
            }}
          />
        ))}
      </div>
    </div>
  );
}
